import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';

import { makeStyles } from '@material-ui/core/styles';
import { Multiselect } from 'react-widgets';
import 'react-widgets/styles.css';

import { Loading } from '../stories/Loading';
import PrimaryButton from './lib/buttons/PrimaryButton';
import { FeatureContext } from '../App';

interface RoomCleanerProps {}

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    textAlign: 'start',
    margin: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
  loadingContainer: {
    textAlign: 'start',
    height: 'calc(100VH - 120px)',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '100VW',
  },
  componentTitle: {
    color: '#142966',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '24px',
    marginBottom: '0px',
  },
  separatorLine: {
    height: '2px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 80px)',
    },
    background: '#004878',
    border: 'none',
  },
  mainContainer: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      marginLeft: '40px',
      marginRight: '40px',
    },
    borderRadius: '4px',
    marginBottom: '12px',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '12px',
  },
  button: {
    maxWidth: '320px',
    width: '100%',
    marginBottom: '24px',
    marginTop: '64px',
    [theme.breakpoints.up('sm')]: {
      alignSelf: 'center',
    },
  },
}));

const RoomCleaners = (props: RoomCleanerProps) => {
  const classes = useStyles();
  const features = useContext(FeatureContext);

  const [loading, setLoading] = useState(false);
  const [uncleanRooms, setUncleanRooms] = useState(new Array<any>());
  const [selectedRooms, setSelectedRooms] = useState<any>();

  useEffect(() => getAllUncleanRooms(), []);

  const getAllUncleanRooms = () => {
    setLoading(true);

    axios
      .get('/api/getAllUncleanRooms')
      .then(({ data }) => {
        setUncleanRooms(data || []);
      })
      .catch((e) => {
        alert('Error fetching data');
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (selectedRooms && selectedRooms.length > 0) {
      setLoading(true);
      const roomIds = selectedRooms.map((r: any) => r.room_details_id);
      axios
        .post('/api/markRoomsClean', roomIds)
        .then(({ data }) => {
          setSelectedRooms([]);
          getAllUncleanRooms();
          alert('Successfully Marked Clean!');
        })
        .catch((e) => {
          alert('Error fetching data');
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      alert('No Rooms Selected!');
    }
  };

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <Loading />
      </div>
    );
  } else {
    return (
      <div className={classes.root}>
        <h2 className={classes.componentTitle}>Room Clean Service</h2>
        <hr className={classes.separatorLine} />
        <div className={classes.mainContainer}>
          <div className={classes.formContainer}>
            <Multiselect
              style={{
                flex: 1,
                width: '100%',
                maxWidth: '320px',
                marginTop: '24px',
              }}
              data={uncleanRooms}
              textField={(info: any) =>
                info.room_name + ' - ' + info.description
              }
              groupBy={(info) =>
                features.groupRoomsByBlockFeatureEnabled
                  ? info.block_name
                  : info.floor_str
              }
              onChange={(r) => {
                setSelectedRooms(r);
              }}
              renderListGroup={({ group }) => {
                return <span>{group}</span>;
              }}
              renderTagValue={({ item }) => {
                return (
                  <span
                    style={{
                      color: '#ff1757',
                      fontWeight: 600,
                    }}
                  >
                    {item.room_name}
                  </span>
                );
              }}
              renderListItem={({ item }) => {
                return (
                  <span
                    style={{
                      color: '#ff4757',
                      fontWeight: 600,
                    }}
                  >
                    {item.room_name} - {item.description}
                  </span>
                );
              }}
            />
            <PrimaryButton onClick={handleSubmit} className={classes.button}>
              MARK CLEAN
            </PrimaryButton>
          </div>
        </div>
        <hr className={classes.separatorLine} />
      </div>
    );
  }
};

export default RoomCleaners;
